import { useCallback, useEffect } from 'react'
import { useNavigation } from '@sketch-hq/sketch-prototype-player'
import { useKey } from 'react-use'
import { usePrototypeViewContext } from '../../hooks'

export function useExitFullscreen() {
  const {
    isFullscreen,
    exitFullscreen,
    toggleOffExitFullscreenButton,
  } = usePrototypeViewContext()

  const {
    currentScreen: { screenArtboardId },
  } = useNavigation()

  const onExitFullscreenButtonClick = useCallback(() => {
    toggleOffExitFullscreenButton()
    exitFullscreen()
  }, [exitFullscreen, toggleOffExitFullscreenButton])

  // Hide the exit fullscreen button on any navigation within the prototype
  useEffect(() => {
    toggleOffExitFullscreenButton()
  }, [screenArtboardId, toggleOffExitFullscreenButton])

  // Pressing escape to exit native fullscreen is default browser behaviour, but
  // we add this key handler as an escape hatch - in case a user has entered the
  // pseudo fullscreen mode with a hidden header and has no visible UI to escape it
  useKey('Escape', () => isFullscreen && exitFullscreen(), {}, [isFullscreen])

  return {
    onExitFullscreenButtonClick,
  } as const
}
